const isNumber = number => typeof number === 'number';

export default isNumber;
